import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export function NoSubscriptionScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/pricing", { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center p-6">
      <Loader2 className="w-6 h-6 text-brand-teal animate-spin" />
    </div>
  );
}
